import type { AccountKey, PaymentMethod, ReportRowKey, TransactionType } from './types';

export const accountLabels: Record<AccountKey, string> = {
  cash: 'Cash Account',
  bank: 'Bank Account'
};

export const shortAccountLabels: Record<AccountKey, string> = {
  cash: 'Cash',
  bank: 'Bank'
};

export const reportRowLabels: Record<ReportRowKey, string> = {
  cash: 'Cash Account',
  bank: 'Bank Account',
  mission: 'Mission Fund'
};

export const paymentMethodLabels: Record<PaymentMethod, string> = {
  cash: 'Cash',
  'bank-transfer': 'Bank transfer',
  'mobile-money': 'Mobile money',
  cheque: 'Cheque',
  other: 'Other'
};

export const typeLabels: Record<TransactionType, string> = {
  income: 'Money received',
  expense: 'Money spent'
};

export function formatMoney(amount: number, currency = 'GHS') {
  return new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency,
    currencyDisplay: 'code',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}

export function formatPlainMoney(amount: number) {
  return new Intl.NumberFormat('en-GH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}

export function formatMonth(month: string) {
  const [year, index] = month.split('-').map(Number);
  return new Intl.DateTimeFormat('en-GH', { month: 'long', year: 'numeric' }).format(new Date(year, index - 1, 1));
}

export function toMonthKey(date: string) {
  return date.slice(0, 7);
}

export function todayInputValue() {
  return new Date().toISOString().slice(0, 10);
}

export function currentMonthKey() {
  return todayInputValue().slice(0, 7);
}

export function safeNumber(value: string | number) {
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}
